<template>
	<div class="payment-purchase-callback-page">
		<b-container>
			<Loading
				v-if="checking"
				text="Deine Zahlung wird geprüft. Bitte warte und schließe das Browserfenster nicht."
			/>
			<div v-else-if="status" class="text-center">
				<Icon :icon="statusIcon" :color="statusColor"/>
				<h3>{{ statusTitle }}</h3>
				<div v-if="status === statusList.notFound">
					Es ist ein Fehler aufgetreten. Bitte wende dich an unseren Support.
				</div>
				<div v-if="status === statusList.aborted">
					Die Zahlung wurde abgebrochen. Du kannst diese neuerlich starten.
				</div>
				<div v-if="status === statusList.success">
					<div>Die Zahlung war erfolgreich. Vielen Dank für deinen Einkauf.</div>
					<div class="mt-1">Die Rechnung erhältst du per E-Mail.</div>
				</div>
				<div v-if="status === statusList.pending">
					<div>Wir konnten die Prüfung noch nicht final abschließen.</div>
					<div class="mt-1">Du erhältst eine E-Mail sobald dies erledigt ist.</div>
				</div>
				<div v-if="status === statusList.error">
					<div>Die Zahlung war leider nicht erfolgreich.</div>
					<div class="mt-1">Versuche es erneut oder wende dich an unseren Support.</div>
				</div>
			</div>
		</b-container>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Get from "@/api/transaction/Get";
import Icon from "@/vue/icon/Icon";

const MAX_TRIES = 20;
const SECONDS_BETWEEN_TRY = 3;

const STATUS_NOT_FOUND = 'not-found';
const STATUS_PENDING = 'pending';
const STATUS_SUCCESS = 'success';
const STATUS_ABORTED = 'aborted';
const STATUS_ERROR = 'error';

const STATUS_ICONS = {
	[STATUS_NOT_FOUND]: 'cross-circle',
	[STATUS_PENDING]: 'question-circle',
	[STATUS_SUCCESS]: 'check-circle',
	[STATUS_ABORTED]: 'question-circle',
	[STATUS_ERROR]: 'cross-circle',
};

const STATUS_TITLES = {
	[STATUS_NOT_FOUND]: 'Fehler',
	[STATUS_PENDING]: 'Zahlung wird noch geprüft',
	[STATUS_SUCCESS]: 'Zahlung erfolgreich',
	[STATUS_ABORTED]: 'Zahlung abgebrochen',
	[STATUS_ERROR]: 'Zahlung nicht erfolgreich',
};

const STATUS_COLORS = {
	[STATUS_NOT_FOUND]: 'red',
	[STATUS_PENDING]: 'yellow',
	[STATUS_SUCCESS]: 'green',
	[STATUS_ABORTED]: 'yellow',
	[STATUS_ERROR]: 'red',
};

export default {

	props: {
		transactionId: {
			type: String,
			required: true,
		},
	},

	components: {
		Loading,
		Icon,
	},

	mounted ()
	{
		this.check();
	},

	data ()
	{
		return {
			tries: 0,
			checking: true,
			status: null,
			statusList: Object.freeze({
				notFound: STATUS_NOT_FOUND,
				pending: STATUS_PENDING,
				success: STATUS_SUCCESS,
				aborted: STATUS_ABORTED,
				error: STATUS_ERROR,
			})
		};
	},

	computed: {
		statusIcon ()
		{
			return STATUS_ICONS[this.status];
		},
		statusTitle ()
		{
			return STATUS_TITLES[this.status];
		},
		statusColor ()
		{
			return STATUS_COLORS[this.status];
		},
	},

	methods: {
		async check ()
		{
			try
			{
				const response = await new Get()
					.setTransactionId(this.transactionId)
					.call();

				const status = response.data.status;

				if (status.error || status.expired)
				{
					this.status = STATUS_ERROR;
					this.checking = false;
					return;
				}

				if (status.aborted)
				{
					this.status = STATUS_ABORTED;
					this.checking = false;
					return;
				}

				if (status.success)
				{
					this.status = STATUS_SUCCESS;
					this.checking = false;
					return;
				}

				if (this.tries++ < MAX_TRIES)
				{
					setTimeout(() => this.check(), SECONDS_BETWEEN_TRY * 1000);
				}
				else
				{
					this.status = STATUS_PENDING;
					this.checking = false;
				}
			}
			catch (e)
			{
				this.status = STATUS_NOT_FOUND;
				this.checking = false;
			}
		}
	}
}
</script>
